import React, { useState, useRef, useEffect } from "react";
import styles from "./ModalTgIntegrationForm.module.scss";
import Button from "../../ui/Button/Button";
import Title from "../../ui/Title/Title";
import Input from "../../ui/Input/Input";
import InputWithMask from "../../ui/InputWithMask/InputWithMask";
import TelegramIcon from "../../assets/icons/TelegramIcon";
import VisibleIcon from "../../assets/icons/VisibleIcon";
import HiddenIcon from "../../assets/icons/HiddenIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveTg,
  setNewBot,
  setNewTg,
} from "../../store/slices/integrationSlice";
import { ClipLoader } from "react-spinners";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "../../ui/Modal/Modal";
import { useModal } from "../../context/ModalContext";
import { getTelegramIntegration, sendUserId } from "../../utils/api/actions/integrations/telegram";

const TelegramSuccessMessage = ({ handleCloseModal }) => {
  const [countdown, setCountdown] = useState(5); // Начальный таймер на 5 секунд
  const dispatch = useDispatch();
  const location = useLocation();
  const { closeModal } = useModal();

  const externalId = location.pathname.split("/").pop();
  const id = localStorage.getItem("@storage_User_Id");

  useEffect(() => {
    // Устанавливаем интервал для обратного отсчета
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    // Закрываем сообщение после завершения обратного отсчета
    if (countdown === 0) {
      handleCloseModal();
      closeModal();
      dispatch(getTelegramIntegration(id, externalId));
      localStorage.removeItem("typeTelegramInit");
      dispatch(setActiveTg(null));
      dispatch(setNewTg(null));
      dispatch(setNewBot(null));
    }

    // Очищаем интервал при размонтировании компонента или завершении обратного отсчета
    return () => clearInterval(timer);
  }, [countdown, closeModal, dispatch, externalId, id, handleCloseModal]);

  return (
    <div className={styles.successMessage}>
      <h2>Вы успешно подключили Telegram!</h2>
      <div>
        <ClipLoader /> Окно закроется через {countdown} секунд.
      </div>
    </div>
  );
};

const ModalTgIntegrationForm = ({ visible, handlerClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state?.user?.data);

  const [activeInputIndex, setActiveInputIndex] = useState(0);
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [errors, setErrors] = useState({ phone: "", code: "", password: "" });
  const [isTelegramConnected, setIsTelegramConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const type = localStorage.getItem("typeTelegramInit");

  const inputRefs = useRef([]);

  useEffect(() => {
    switch (type) {
      case "phone":
        setStep(1);
        break;
      case "code":
        setStep(2);
        break;
      case "password":
        setStep(3);
        break;
      default:
        setStep(1);
        break;
    }
  }, [type]);

  const sanitizeValue = (value) => value.replace(/[-_\s]/g, "");

  const nextStep = () => {
    let userData;

    if (step === 1) {
      userData = {
        userId: user.id,
        clientIdentifier: phone
          ? sanitizeValue(phone)
          : localStorage.getItem("userPhone"),
        type: "phone",
        value: sanitizeValue(phone),
      };
      localStorage.setItem("userPhone", sanitizeValue(phone));
      dispatch(
        sendUserId(
          userData,
          setStep,
          setLoading,
          setIsTelegramConnected,
          setError,
          navigate
        )
      );
    } else if (step === 2) {
      userData = {
        userId: user.id,
        clientIdentifier: phone
          ? sanitizeValue(phone)
          : localStorage.getItem("userPhone"),
        type: "code",
        value: code,
      };
      console.log("data code", userData);
      dispatch(
        sendUserId(
          userData,
          setStep,
          setLoading,
          setIsTelegramConnected,
          setError,
          navigate
        )
      );
    } else if (step === 3 && !isTelegramConnected) {
      // Третий шаг доступен только если Telegram еще не подключен
      userData = {
        userId: user.id,
        clientIdentifier: phone
          ? sanitizeValue(phone)
          : localStorage.getItem("userPhone"),
        type: "password",
        value: password,
      };
      dispatch(
        sendUserId(
          userData,
          setStep,
          setLoading,
          setIsTelegramConnected,
          setError,
          navigate
        )
      );
    }
  };

  const validateInputs = () => {
    const newErrors = { phone: "", code: "", password: "" };

    if (step === 1 && sanitizeValue(phone).length < 11) {
      newErrors.phone = "Некорректный номер";
    }
    if (step === 2 && code.replace(/[_ ]/g, "").length < 5) {
      newErrors.code = "Поле не может быть пустым";
    }
    if (step === 3 && !password) {
      newErrors.password = "Поле не может быть пустым";
    }
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    const updatedCode = code.split("");
    updatedCode[index] = value || "";
    setCode(updatedCode.join(""));

    const newErrors = {
      ...errors,
      code: updatedCode.join("").trim() ? "" : "Поле не может быть пустым",
    };
    setErrors(newErrors);

    if (value && index < inputRefs.current.length - 1) {
      setActiveInputIndex(index + 1);
      inputRefs.current[index + 1].focus();
    } else if (!value && index > 0) {
      setActiveInputIndex(index - 1);
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePhoneChange = (e) => {
    const newPhone = e.target.value;
    setPhone(newPhone);
    setErrors({
      ...errors,
      phone: sanitizeValue(newPhone).length === 11 ? "" : "Некорректный номер",
    });
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setErrors({
      ...errors,
      password: newPassword.trim() ? "" : "Поле не может быть пустым",
    });
  };

  const handlerVisiblePassword = () => setVisiblePassword(!visiblePassword);

  const handleKeyDown = (e) => {
    if (
      (!errors.phone || !errors.code || !errors.password) &&
      e.key === "Enter"
    ) {
      nextStep();
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div className={styles.inputGroup}>
            <div className={styles.inputContainer}>
              <InputWithMask
                className={styles.child}
                label="Номер телефона"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={`${styles.input} ${
                  errors.phone ? styles.error : ""
                }`}
                value={phone}
                placeholder={"7 999 - 999 - 99 - 99"}
                onChange={handlePhoneChange}
                onKeyPress={handleKeyDown}
              />
            </div>
            {errors.phone && <p className={styles.errorText}>{errors.phone}</p>}
            {error && <p className={styles.errorText}>{error}</p>}
          </div>
        );
      case 2:
        return (
          <div className={styles.inputGroup}>
            {isTelegramConnected ? (
              <TelegramSuccessMessage handleCloseModal={handlerClose} />
            ) : (
              <>
                <div className={styles.inputGroupTitle}>Введите код</div>
                <div className={styles.inputContainer}>
                  {["", "", "", "", ""].map((_, index) => (
                    <Input
                      key={`input-code-${index}`}
                      className={styles.child}
                      labelStyle={styles.labelInput}
                      backgroundStyle={styles.labelBackground}
                      inputStyle={`${styles.inputCode} ${
                        index === activeInputIndex ? styles.active : ""
                      }`}
                      name="name"
                      maxLength="1"
                      value={code[index] || ""}
                      refFocus={(el) => (inputRefs.current[index] = el)}
                      onChange={(e) => handleInputChange(e, index)}
                      type={"text"}
                    />
                  ))}
                </div>
                {errors.code && (
                  <p className={styles.errorText}>{errors.code}</p>
                )}
                {error && <p className={styles.errorText}>{error}</p>}
              </>
            )}
          </div>
        );
      case 3:
        // Проверка условия перед рендером третьего шага
        if (isTelegramConnected) {
          return <TelegramSuccessMessage handleCloseModal={handlerClose} />; // Пропускаем третий шаг, если подключение завершено
        }
        return (
          <div className={styles.inputGroup}>
            <>
              <div className={styles.inputContainer}>
                <Input
                  className={styles.child}
                  label="Облачный пароль"
                  labelStyle={styles.labelInput}
                  backgroundStyle={styles.labelBackground}
                  inputStyle={`${styles.input} ${
                    errors.password ? styles.error : ""
                  }`}
                  value={password}
                  placeholder={"Пароль"}
                  type={visiblePassword ? "text" : "password"}
                  rightIcon={visiblePassword ? <VisibleIcon /> : <HiddenIcon />}
                  onClickRightIcon={handlerVisiblePassword}
                  onChange={handlePasswordChange}
                />
              </div>
              {errors.password && (
                <p className={styles.errorText}>{errors.password}</p>
              )}
              {error && <p className={styles.errorText}>{error}</p>}
            </>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Modal visible={visible} handleClose={handlerClose}>
      <div className={styles.layout}>
        <div className={styles.header}>
          <Title title="Новая интеграция" className={styles.title} />
          <TelegramIcon width={25} height={25} />
        </div>

        <div className={styles.content}>
          <div className={styles.steps}>
            {[1, 2, 3].map((stepNumber, index) => (
              <React.Fragment key={stepNumber}>
                <div
                  className={`${styles.step} ${
                    stepNumber === step ? styles.active : ""
                  }`}
                >
                  {stepNumber}
                </div>
                {index < 2 && (
                  <div className={styles.dashedLine}>
                    {stepNumber < step && (
                      <div className={styles.completedContainer}>✓</div>
                    )}
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

          <div className={styles.body}>
            {renderStep()}
            {step < 3 && !isTelegramConnected ? (
              <Button
                title="Далее"
                onClick={() => (validateInputs() ? nextStep() : undefined)}
                className={styles.nextButton}
                titleClassName={styles.nextButtonTitle}
                leftIcon={
                  loading ? <ClipLoader size={20} color="white" /> : null
                }
              />
            ) : (
              !isTelegramConnected && (
                <Button
                  title="Отправить"
                  onClick={() => (validateInputs() ? nextStep() : undefined)}
                  className={styles.nextButton}
                  titleClassName={styles.nextButtonTitle}
                  leftIcon={
                    loading ? <ClipLoader size={20} color="white" /> : null
                  }
                />
              )
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalTgIntegrationForm;
